import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ChatInboxService } from '../../services/chat-inbox/chat-inbox.service';
import { IChatInboxPostMessage, ChatInboxMessageTypes } from '../../models/integrations/chat-inbox.model';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'chat-inbox-notification',
  templateUrl: './chat-inbox-notification.component.html',
  styleUrls: ['./chat-inbox-notification.component.scss']
})
export class ChatInboxNotificationComponent implements OnInit, OnDestroy {

  public notificationTypes = ChatInboxMessageTypes;

  @Input() notification: IChatInboxPostMessage;

  public autoHideDelay: number = 10 * 1000; //seconds

  constructor(
    private chatInboxService: ChatInboxService,
    private router: Router
  ){}

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  public openChat(): void {
    this.dismiss();
    this.router.navigate(['home', 'inbox']);
  }

  public dismiss(evt: InputEvent = null): void {
    evt?.stopImmediatePropagation();
    evt?.stopPropagation();
    this.chatInboxService.removeNotification(this.notification);
  }

  public onHide() {
    this.dismiss();
  }
}
